/** Glory league common breakpoints and dimensions */

export const MAX_CONTENT_WIDTH = 1080;
export const MOBILE_LAYOUT_BREAKPOINT = 1024; // screens smaller than this are considered mobile
